import {useRef, useEffect} from "react";
import { useScroll, useDebounceEffect } from 'ahooks';
import {useEffectOnActive} from "@hhhgamehhh/keepalive-for-react";

const useRestoreScroll = (ref, delay, isSmooth = false) => {
  const scrollHistory = useRef(0);
  const scroll = useScroll(ref)
  let timer = null

  useDebounceEffect(() => {
    if (scroll) {
      scrollHistory.current = scroll?.top
    }
  }, [scroll], {wait: 200});

  useEffectOnActive(() => {
    if (ref.current) {
      let originalWidth = ref.current.style.width
      ref.current.style.display = 'none'
      timer = window.setTimeout(() => {
        if (isSmooth) {
          ref?.current?.scrollTo(
            {
              top: scrollHistory?.current,
              behavior: 'smooth'
            })
          ref.current.style.width = originalWidth //'auto'
          ref.current.style.display = 'block'
        } else {
          ref.current.style.display = 'block'
          ref.current.style.width = originalWidth //'auto'
          ref.current.scrollTop = scrollHistory?.current
        }
      }, 200)
    }
    return () => {
      clearTimeout(timer)
      // scrollHistory.current = 0
    }
  }, [])

  const clearScroll = () => {
    clearTimeout(timer)
    scrollHistory.current = 0
  }
  return clearScroll
}

export default useRestoreScroll;
